(function () {
  const STORAGE_KEY = 'engelai-widget-pos';

  function loadPos() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch { return null; }
  }

  function savePos(left, top) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ left, top }));
    } catch { }
  }

  function clampAndApply(wrapper, left, top) {
    const rect = wrapper.getBoundingClientRect();
    const w = rect.width || 80;
    const h = rect.height || 80;
    left = Math.max(0, Math.min(left, window.innerWidth - w));
    top = Math.max(0, Math.min(top, window.innerHeight - h));
    wrapper.style.right = 'auto';
    wrapper.style.bottom = 'auto';
    wrapper.style.left = left + 'px';
    wrapper.style.top = top + 'px';
    return { left, top };
  }

  function initDragger(wrapper, handle) {
    const saved = loadPos();
    if (saved) clampAndApply(wrapper, saved.left, saved.top);
    requestAnimationFrame(() => { document.body.classList.add('engelai-ready'); });

    handle.style.cursor = 'grab';

    let active = false;
    let moved = false;
    let startPX, startPY, startLeft, startTop;

    function pointerXY(e) {
      const src = e.touches ? e.touches[0] : e;
      return { x: src.clientX, y: src.clientY };
    }

    function onStart(e) {
      const rect = wrapper.getBoundingClientRect();
      const p = pointerXY(e);
      startPX = p.x;
      startPY = p.y;
      startLeft = rect.left;
      startTop = rect.top;
      active = true;
      moved = false;
      handle.style.cursor = 'grabbing';
      wrapper.style.transition = 'none';
      wrapper.style.userSelect = 'none';

      if (e.touches) {
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
        document.addEventListener('touchcancel', onEnd);
      } else {
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
      }
    }

    function onMove(e) {
      if (!active) return;
      if (e.cancelable) e.preventDefault();
      const p = pointerXY(e);
      const dx = p.x - startPX;
      const dy = p.y - startPY;
      if (!moved && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
      moved = true;
      clampAndApply(wrapper, startLeft + dx, startTop + dy);
    }

    function onEnd() {
      if (!active) return;
      active = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onEnd);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('touchend', onEnd);
      document.removeEventListener('touchcancel', onEnd);
      handle.style.cursor = 'grab';
      wrapper.style.userSelect = '';

      if (moved) {
        const rect = wrapper.getBoundingClientRect();
        savePos(rect.left, rect.top);

        // suppress the click that fires after touchend/mouseup on a drag
        document.addEventListener('click', stopClick, { capture: true, once: true });
      }
    }

    function stopClick(e) {
      e.stopPropagation();
    }

    handle.addEventListener('mousedown', onStart);
    handle.addEventListener('touchstart', onStart, { passive: true });

    window.addEventListener('resize', () => {
      const rect = wrapper.getBoundingClientRect();
      const { left, top } = clampAndApply(wrapper, rect.left, rect.top);
      savePos(left, top);
    });
  }

  function waitForBot() {
    const id = setInterval(() => {
      const bot = document.querySelector('enegelai-bot');
      if (!bot?.shadowRoot) return;
      const wrapper = bot.shadowRoot.querySelector('.cb-wrapper');
      const handle = bot.shadowRoot.querySelector('cb-header');
      if (!wrapper || !handle) return;
      clearInterval(id);
      initDragger(wrapper, handle);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForBot);
  } else {
    waitForBot();
  }
})();
